import './forms.scss';

import * as inputs from './Inputs';

module.exports = {
  ...inputs
}



// WEBPACK FOOTER //
// ./components/forms/index.js